      Study Materials
      <span class="count-badge">{{ studyMaterials.length }}</span>
  <div class="main-card mt-4 rounded-4">
 <div  class="resource-grid">
      <div class="material-card" *ngFor="let material of studyMaterials">
        <div class="material-header">
          <div class="material-icon">
            <img src="assets/images/docs.svg" alt="material-icon" width="24" height="24" />
          </div>
          <h5 class="material-title">{{ material.title }}</h5>
        </div>
        <div class="material-details">
          <div class="material-date">
            <img src="assets/images/calendar_today.svg" width="16" height="16" class="me-1" />
            <span>{{ material.date }}</span>
          </div>
          <div class="material-size">{{ material.size }}</div>
        </div>
        <div class="divider"></div>
        <button class="download-btn">
          <img src="assets/images/download.png" alt="download-icon" width="16" height="16" class="view-icon" />
          Download
        </button>
      </div>
  </div>
</div>